import Vue from 'vue'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  props: {
    value: {
      type: Object,
      default: null
    },
   
    originStops: {
      type: Array,
      required: true
    },

    destinationStops: {
      type: Array,
      required: true
    },

    variants: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      tabIndexInit: 200,

      filters: {
        originStopId: null,
        destinationStopId: null,
        variantId: null,
        ...this.value
      },
      originStopParcialName: '',
      originStopTimeOut: null,
      destinationStopParcialName: '',
      destinationStopTimeOut: null,
      preventTextEvent: false
    }
  },

  computed: {
    showVariantsSelect() {
      const {config} = this.administrativeArea
      return config && config.allow_variants_selection
    },

    selectedStops() {
      return this.filters.originStopId && this.filters.destinationStopId
    },

    originStopsOptions() {
      return this.stopsOptions(this.originStops)
    },

    destinationStopsOptions() {
      return this.stopsOptions(this.destinationStops)
    },

    variantsOptions() {
      return this.variants.map(v => ({label: this.variantName(v), value: v.id}))
    },

    firstMaskVariant() {
      return this.variants.find(v => v.mask === 1)
    },

    longestVariant() {
      return _.orderBy(this.variants, 'length', 'desc')[0]
    },

    defaultVariant() {
      return this.firstMaskVariant || this.longestVariant
    },

    disabledDestinationStops() {
      return !this.filters.originStopId
    },

    disabledVariants() {
      return !this.selectedStops || !this.variants.length
    }
  },

  watch: {
    filters: {
      handler() { this.$emit('input', this.filters) },
      deep: true
    },

    variants: {
      handler(array) { if (array.length) { this.filters.variantId = this.defaultVariant.id } },
      deep: true
    }
  },

  methods: {
    stopsOptions(stops) {
      return stops.map(s => ({label: this.stopName(s), value: s.id}))
    },

    stopName(stop) {
      return `${stop.display_code} | ${stop.name}`
    },

    variantName(variant) {
      const {name, length} = variant

      return this.$t('prePurchaseFares.interurban.variantName', {name, length})
    },

    updateOriginParcialName(name) {
      if (this.preventTextEvent) {
        this.preventTextEvent = false

        return
      }

      clearTimeout(this.originStopTimeOut)

      this.originStopTimeOut = setTimeout(() => {
        this.originStopParcialName = name
        this.filters.originStopId = null
        this.filterOriginStops()
      }, 500)
    },

    updateDestinationParcialName(name) {
      if (this.preventTextEvent) {
        this.preventTextEvent = false

        return
      }

      clearTimeout(this.destinationStopTimeOut)

      this.destinationStopTimeOut = setTimeout(() => {
        this.destinationStopParcialName = name
        this.filters.destinationStopId = null
        this.filterDestinationStops()
      }, 500)
    },

    originStopChanged() {
      clearTimeout(this.originStopTimeOut)
      this.originStopParcialName = ''
      this.preventTextEvent = true
    },

    destinationStopChanged() {
      clearTimeout(this.destinationStopTimeOut)
      this.destinationStopParcialName = ''
      this.preventTextEvent = true
    },

    filterOriginStops() {
      this.$emit('get-origin-stops', this.originStopParcialName)
    },

    filterDestinationStops() {
      this.$emit('get-destination-stops', this.destinationStopParcialName)
    },

    toggleOriginSelector(value) {
      // Al cerrar
      if (!value) {
        clearTimeout(this.originStopTimeOut)

        // Y haber filtrado sin seleccionar ninguno
        if (this.originStopParcialName && !this.filters.originStopId) {
          this.originStopParcialName = ''

          this.filterOriginStops()
        }
      }
    },

    toggleDestinationSelector(value) {
      // Al cerrar
      if (!value) {
        clearTimeout(this.destinationStopTimeOut)

        // Y haber filtrado sin seleccionar ninguno
        if (this.destinationStopParcialName && !this.filters.destinationStopId) {
          this.destinationStopParcialName = ''

          this.filterDestinationStops()
        }
      }
    },

    handleSubmit() {
      this.$emit('submit')
    }
  }
})
